import { useCallback } from 'react';

import type { CredentialPage } from '@rtkwlf/rendall';
import { useTranslation } from 'react-i18next';

import { useScannerScanCredentials } from '@apis/rendall/queries/use-scanner-scan-credentials/use-scanner-scan-credentials';

import type { CredentialedScanningRow } from '../types';
import { CredentialedScanningType } from '../types';

export const useScannerScanCredentialsWrapper = (scannerId: string) => {
  const { t } = useTranslation('telemetryScannerConfig', {
    keyPrefix: 'credentialedScanningForm.typeOption',
  });

  return useScannerScanCredentials(scannerId, {
    select: useCallback(
      (page: CredentialPage): CredentialedScanningRow[] => {
        return page.items.map((row) => ({
          ...row,
          credScanningTypeStr:
            row.type === CredentialedScanningType.Usk
              ? t('usernameSSHKey')
              : t('usernameOrPass'),
          targetStr: row.targets.join(),
        }));
      },
      [t],
    ),
  });
};
